<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div [formGroup]="filterForm">
    <p-table
      #rolesTable
      [value]="roles"
      [loading]="isLoading"
      dataKey="id"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50]"
      styleClass="p-datatable-striped"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Roles</h2>

          <div class="ml-auto">
            <p-button
              label="New Role"
              icon="pi pi-plus"
              (onClick)="createRole()"
            ></p-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="roleName">
            Name
            <p-sortIcon field="roleName"></p-sortIcon>
          </th>
          <th pSortableColumn="description">
            Description
            <p-sortIcon field="description"></p-sortIcon>
          </th>
          <th style="width: 8rem">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-role>
        <tr>
          <td>{{ role.roleName }}</td>
          <td>{{ role.description }}</td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editRole(role.id)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteRole(role)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center p-4">No roles found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
